import { jsxs as j, jsx as s } from "react/jsx-runtime";
import { forwardRef as w, useRef as x, useImperativeHandle as P, useEffect as _ } from "react";
import { c as F } from "../../cn-gv_k3DnN.js";
import { Input as i } from "../input/input.js";
function f(e) {
  if (!e) return {};
  const [n] = e.split("T"), [u = "", r = "", a = ""] = n.split("-");
  return { year: u, month: r, day: a };
}
function d(e) {
  const { year: n, month: u, day: r } = f(e);
  return `${n ?? ""}-${u ? u.padStart(2, "0") : ""}-${r ? r.padStart(2, "0") : ""}`;
}
const H = (e) => e.replace(/\D/g, ""), b = w(
  ({
    disabled: e,
    hasError: n,
    className: u,
    defaultValue: r,
    onChange: a,
    value: o,
    id: D,
    placeholderDay: h = "DD",
    placeholderMonth: I = "MM",
    placeholderYear: g = "YYYY",
    ...v
  }, V) => {
    const c = x(null), p = x(null), M = d(o ?? r), {
      year: $,
      month: Y,
      day: N
    } = f(M);
    P(V, () => ({
      ...c.current,
      // Set the focus on the first input
      focus: () => {
        var t;
        return (t = p.current) == null ? void 0 : t.focus();
      }
    }), []), _(() => {
      if (o) {
        const t = d(o);
        a == null || a(t);
      }
    }, []);
    function l(t, R) {
      if (!c.current) return;
      t.currentTarget.value = H(t.currentTarget.value);
      const { value: T } = t.currentTarget, m = f(c.current.value);
      m[R] = T;
      const { year: L = "", month: O = "", day: S = "" } = m, y = d(`${L}-${O}-${S}`);
      c.current.value = y, a == null || a(y);
    }
    return /* @__PURE__ */ j(
      "fieldset",
      {
        className: F("grid grid-cols-[1fr_1fr_2fr] gap-sp-2", u),
        disabled: e,
        children: [
          /* @__PURE__ */ s(
            "input",
            {
              className: "hidden",
              ref: c,
              defaultValue: r !== void 0 ? d(r) : void 0,
              value: o !== void 0 ? d(o) : void 0,
              readOnly: !0,
              ...v
            }
          ),
          /* @__PURE__ */ s(
            i,
            {
              ref: p,
              type: "text",
              onChange: (t) => l(t, "month"),
              inputMode: "numeric",
              placeholder: I,
              maxLength: 2,
              hasError: n,
              defaultValue: Y,
              id: D
            }
          ),
          /* @__PURE__ */ s(
            i,
            {
              type: "text",
              onChange: (t) => l(t, "day"),
              inputMode: "numeric",
              placeholder: h,
              maxLength: 2,
              hasError: n,
              defaultValue: N
            }
          ),
          /* @__PURE__ */ s(
            i,
            {
              type: "text",
              onChange: (t) => l(t, "year"),
              inputMode: "numeric",
              placeholder: g,
              maxLength: 4,
              hasError: n,
              defaultValue: $
            }
          )
        ]
      }
    );
  }
);
b.displayName = "DateInput";
export {
  b as DateInput
};
